var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.95833C1.375 3.42703 3.42703 1.375 5.95833 1.375H16.0417C18.573 1.375 20.625 3.42703 20.625 5.95833V16.0417C20.625 18.573 18.573 20.625 16.0417 20.625H5.95833C3.42703 20.625 1.375 18.573 1.375 16.0417V5.95833Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75915 5.5H4.93949L9.46823 11.4819L5.2292 16.5H7.18777L10.3939 12.7046L13.2408 16.4651H17.0605L12.4002 10.3093L12.4084 10.3199L16.421 5.56985H14.4625L11.4826 9.09735L8.75915 5.5ZM7.04788 6.54763H8.237L14.9521 15.4174H13.763L7.04788 6.54763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.9b3aeeb42822969c1f7ba975fc80cf1f.svg";
export { ForwardRef as ReactComponent };